var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6618 8.6636C12.6618 9.0171 12.5213 9.35612 12.2714 9.60608C12.0214 9.85604 11.6824 9.99646 11.3289 9.99646H3.33174L0.666016 12.6622V1.9993C0.666016 1.64581 0.806441 1.30679 1.0564 1.05683C1.30636 0.806869 1.64538 0.666443 1.99888 0.666443H11.3289C11.6824 0.666443 12.0214 0.806869 12.2714 1.05683C12.5213 1.30679 12.6618 1.64581 12.6618 1.9993V8.6636Z",
    stroke: "#155DFC",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon17);
export default __webpack_public_path__ + "static/media/icon17.1ab882fb05aa914bbcf1c3dccb73405c.svg";
export { ForwardRef as ReactComponent };